import { jsxs as y, jsx as p, Fragment as le } from "react/jsx-runtime";
import { useState as v, useEffect as C, startTransition as ge, useMemo as A, useRef as se, useCallback as b } from "react";
import { C as ye } from "./CardGrid-JhNXXSJv.js";
import { D, b as Te, A as ve, a as B, M as Ce, s as M, r as P, g as w } from "./MapView-C6gXpjuJ.js";
import { a as Ae, D as _e, u as xe, b as Se, f as Le, e as Q, g as Me, c as we, d as Re, P as Fe, N as De } from "./location-query-DoEWhnej.js";
import { T as V, u as Ee, B as X } from "./useMediaQuery-BZAMobKw.js";
import { M as Pe } from "./MultiRangeSlider-CRKon3yy.js";
import { F as L } from "./FlexContainer-CoykMrGV.js";
import { I as J } from "./Tooltip-DLbZm45k.js";
import { S as Oe } from "./Section-DOeCOW54.js";
import { S as ke } from "./ApartmentCard-BfyZfamk.js";
const W = {
  "dropdown-range": "elo-dropdown-range",
  "dropdown-range__inputs": "elo-dropdown-range__inputs"
}, Z = (a) => {
  const {
    scaleFrom: t,
    scaleTo: e,
    defaultMin: r = t,
    defaultMax: o = e,
    onChange: s,
    texts: l,
    scaleStep: m
  } = a, [i, u] = v(() => ({
    min: Math.max(t, r),
    max: Math.min(e, o)
  }));
  return C(() => {
    ge(() => {
      s == null || s(i);
    });
  }, [i, s]), /* @__PURE__ */ y("div", { className: W["dropdown-range"], children: [
    /* @__PURE__ */ p(V, { size: "mediumBold", type: "label", children: l.title }),
    /* @__PURE__ */ p(
      Pe,
      {
        min: t,
        max: e,
        value: i,
        step: m,
        onChange: u
      }
    ),
    /* @__PURE__ */ y(L, { justifyContent: "space-between", children: [
      /* @__PURE__ */ p(V, { size: "small", type: "label", children: l.fromText ?? t }),
      /* @__PURE__ */ p(V, { size: "small", type: "label", children: l.toText ?? e })
    ] }),
    /* @__PURE__ */ y("div", { className: W["dropdown-range__inputs"], children: [
      /* @__PURE__ */ p(
        J,
        {
          label: l.minimumText ?? "From",
          required: !0,
          value: i.min,
          type: "number",
          min: i.min,
          max: i.max,
          step: m,
          onChange: (d) => {
            const n = Number.parseInt(d.currentTarget.value.trim(), 10);
            u((c) => {
              let f = Math.max(t, n);
              return f >= c.max && (f = Math.max(t, c.max - 1)), { ...c, min: f };
            });
          }
        }
      ),
      /* @__PURE__ */ p(
        J,
        {
          label: l.maximumText ?? "To",
          required: !0,
          type: "number",
          value: i.max,
          min: i.min,
          max: i.max,
          step: m,
          onChange: (d) => {
            const n = Number.parseInt(d.currentTarget.value.trim(), 10);
            u((c) => ({ ...c, max: Math.min(e, n) }));
          }
        }
      )
    ] })
  ] });
}, Ie = "elo-tablet", Ne = "elo-mobile", Be = {
  "apartment-search": "elo-apartment-search",
  tablet: Ie,
  mobile: Ne,
  "apartment-search__sort-by": "elo-apartment-search__sort-by"
}, Ve = ["1h", "2h", "3h", "4h"], O = [
  "availabilityAvailableNow",
  "availabilityAvailableSoon"
], h = {
  location: "location",
  roomCount: "room-count",
  availability: "availability",
  area: "area",
  rent: "rent"
}, T = {
  location: "Location",
  roomCount: "MeetingRoom",
  availability: "Calender",
  area: "Square",
  rent: "Euro"
}, ee = null;
function $e(a, { area: t, rent: e, tags: r }) {
  if (!ze(a, e) || !Ge(a, t)) return !1;
  const o = r.filter(
    (l) => l.type === h.roomCount
  );
  if (o.length > 0 && !o.some((l) => Ue(a, l.value)))
    return !1;
  const s = r.filter(
    (l) => l.type === h.availability
  );
  return !(s.length > 0 && !s.some(
    (l) => ce(a, l.data ?? l.value)
  ));
}
function Ue(a, t) {
  var e;
  if (t.length === 2)
    return (e = a.layout) == null ? void 0 : e.toLowerCase().includes(t == null ? void 0 : t.toLowerCase());
  if (t.includes("+")) {
    const r = Number.parseInt(t.slice(0, 1), 10);
    return Number.parseInt(
      a.layout.slice(0, 1),
      10
    ) >= r;
  }
  return !1;
}
function ze(a, t) {
  return a.rent >= t.min && a.rent <= t.max;
}
function Ge(a, t) {
  return a.size >= t.min && a.size <= t.max;
}
function ce(a, t) {
  switch (t) {
    case O[0]:
      return !a.availableFromDate || new Date(a.availableFromDate).valueOf() <= Date.now();
    case O[1]:
      return !!a.availableFromDate && new Date(a.availableFromDate).valueOf() > Date.now();
    default:
      return !1;
  }
}
function me(a, t) {
  const e = a.apartments.map((s) => ({
    layout: s.layout,
    size: s.size.toString(),
    rent: `${s.rent} €/kk`
  })), r = a.apartmentDistrict ? [a.apartmentDistrict, a.apartmentPropertyCity].filter(Boolean).join(", ") : a.apartmentPropertyCity, o = a.apartments.some(
    (s) => ce(s, O[0])
  );
  return {
    title: a.apartmentPropertyName,
    subtitle: r,
    image: a.apartmentPropertyImageUrl ?? "",
    url: a.apartmentPropertyUrl,
    tagText: o ? t.apartmentsAvailableText ?? t.availabilityAvailableNowText : t.availabilityAvailableSoonText,
    apartmentListValues: e,
    buttonUrl: a.apartmentPropertyUrl,
    apartmentDetails: !1,
    buttonText: t.apartmentsButtonText
  };
}
function Ke(a, t) {
  const e = me(a, t);
  return {
    apartmentPropertyTitle: e.title,
    apartmentPropertySubtitle: e.subtitle,
    apartmentPropertyImageUrl: e.image,
    apartmentPropertyUrl: e.url ?? "",
    lat: a.lat,
    lng: a.lng,
    ...e
  };
}
const Ye = (a) => {
  const { properties: t, texts: e } = a, r = A(
    () => t.map(
      (o) => ({
        type: "apartment",
        data: me(o, e)
      })
    ),
    [t, e]
  );
  return /* @__PURE__ */ p(ye, { cardData: r });
}, je = ({
  roomCountOptions: a,
  availabilityOptions: t,
  areaOptions: e,
  rentOptions: r,
  texts: o
}) => /* @__PURE__ */ y(le, { children: [
  a ? /* @__PURE__ */ p(
    D,
    {
      filterIcon: T.roomCount,
      filterLabel: o.roomCountFilterLabel,
      disabled: a.length === 0,
      children: /* @__PURE__ */ p(Ae, { items: a })
    }
  ) : null,
  e ? /* @__PURE__ */ p(
    D,
    {
      filterIcon: T.area,
      filterLabel: o.areaFilterLabel,
      children: /* @__PURE__ */ p(Z, { ...e })
    }
  ) : null,
  r ? /* @__PURE__ */ p(
    D,
    {
      filterIcon: T.rent,
      filterLabel: o.rentFilterLabel,
      children: /* @__PURE__ */ p(Z, { ...r })
    }
  ) : null,
  t ? /* @__PURE__ */ p(
    D,
    {
      filterIcon: T.availability,
      filterLabel: o.availabilityFilterLabel,
      disabled: t.length === 0,
      children: /* @__PURE__ */ p(_e, { items: t })
    }
  ) : null
] }), qe = "elo-mobile", S = {
  "apartment-search-filter": "elo-apartment-search-filter",
  "apartment-search-filter__sticky-container": "elo-apartment-search-filter__sticky-container",
  "apartment-search-filter__container": "elo-apartment-search-filter__container",
  mobile: qe,
  "apartment-search-filter__container__chips": "elo-apartment-search-filter__container__chips",
  "apartment-search-filter__container__button": "elo-apartment-search-filter__container__button",
  "apartment-search-filter__tags": "elo-apartment-search-filter__tags",
  "apartment-search-filter__sort-by": "elo-apartment-search-filter__sort-by"
}, He = ({
  autocompleteInputProps: a,
  mapButton: t,
  texts: e,
  selectedTags: r,
  onRemoveAllTags: o,
  onRemoveTag: s,
  filters: l
}) => {
  const m = Ee("(max-width: 490px)"), { isOpen: i, handleOpeningModal: u, handleClosingModal: d } = xe(), n = /* @__PURE__ */ p(je, { ...l }), c = r.find(
    (f) => f.type === h.location
  );
  return /* @__PURE__ */ y(
    Oe,
    {
      id: "apartment-search-filter",
      className: S["apartment-search-filter__sticky-container"],
      children: [
        /* @__PURE__ */ p(
          Te,
          {
            heading: e.modalHeadingText,
            isOpen: i,
            onClose: d,
            onClearFilters: o,
            tagIsSelected: r.length === 0,
            clearFiltersButtonText: e.clearFiltersButtonText,
            displayResultsButtonText: e.displayResultsButtonText,
            children: n
          }
        ),
        /* @__PURE__ */ y(
          L,
          {
            direction: "column",
            className: S["apartment-search-filter"],
            children: [
              /* @__PURE__ */ y(L, { className: S["apartment-search-filter__container"], children: [
                /* @__PURE__ */ p(
                  ve,
                  {
                    ...a
                  },
                  c == null ? void 0 : c.value
                ),
                /* @__PURE__ */ p(
                  L,
                  {
                    direction: "row",
                    className: S["apartment-search-filter__container__chips"],
                    children: n
                  }
                ),
                m && c ? /* @__PURE__ */ p(
                  B,
                  {
                    icon: c.icon,
                    tag: c.value,
                    onRemoveTag: () => s(c)
                  }
                ) : null,
                /* @__PURE__ */ p(
                  X,
                  {
                    iconLeft: "Tune",
                    className: S["apartment-search-filter__container__button"],
                    onClick: u,
                    small: !1,
                    children: e.modalOpenerButtonText
                  }
                ),
                m && /* @__PURE__ */ p(
                  X,
                  {
                    variant: "secondary",
                    iconLeft: "Map",
                    onClick: t.onClickMapView,
                    disabled: t.disableMapView,
                    small: !1,
                    children: t.isDisplayingMapView ? t.openCardViewButtonText : t.openMapViewButtonText
                  }
                )
              ] }),
              m ? null : /* @__PURE__ */ y(
                L,
                {
                  className: S["apartment-search-filter__tags"],
                  justifyContent: "center",
                  children: [
                    r.map((f, g) => /* @__PURE__ */ p(
                      B,
                      {
                        icon: f.icon,
                        tag: f.value,
                        onRemoveTag: () => s(f)
                      },
                      g
                    )),
                    r.length > 1 && /* @__PURE__ */ p(
                      B,
                      {
                        lastTagText: e.removeAllTagsText,
                        onRemoveAllTags: o
                      },
                      "remove-all"
                    )
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  );
}, Qe = (a) => {
  const { googleMapApiKey: t, properties: e, texts: r } = a, o = A(
    () => e.map(
      (s) => Ke(s, r)
    ),
    [e, r]
  );
  return /* @__PURE__ */ p(
    Ce,
    {
      googleMapsApiKey: t,
      cardText: r.mapViewCardDataHeader,
      cardData: o,
      cardType: "apartment"
    }
  );
}, $ = "elo-apartments-filter-area", G = { min: 0, max: 200 };
function Xe(a, t, e) {
  const r = se(G), [o, s] = v(G), { addUniqueTagOfType: l, removeTagsByType: m } = e, i = b(
    (n) => {
      s(n);
      const c = r.current;
      c.min !== n.min || c.max !== n.max ? (l({
        type: h.area,
        value: `${n.min}-${n.max} m2`,
        icon: T.area
      }), M($, n)) : (m(h.area), P($));
    },
    [l, m]
  );
  C(() => {
    const n = Je(a);
    r.current = n;
    const c = w($);
    i(c ?? n);
  }, [a, i]);
  const u = A(() => {
    const n = r.current;
    return {
      scaleFrom: n.min,
      scaleTo: n.max,
      defaultMin: o.min,
      defaultMax: o.max,
      onChange: i,
      texts: {
        title: t.areaFilterLabel,
        fromText: `${n.min} m2`,
        toText: `${n.max} m2`,
        maximumText: t.maximumLabel,
        minimumText: t.minimumLabel
      }
    };
  }, [
    o,
    i,
    t.areaFilterLabel,
    t.maximumLabel,
    t.minimumLabel
  ]), d = b(() => {
    const n = r.current;
    i(n);
  }, [i]);
  return { area: o, areaOptions: u, resetArea: d };
}
function Je(a) {
  if (a.length === 0)
    return G;
  const t = 10;
  let e = 0;
  return a.forEach((r) => {
    r.apartments.forEach((o) => {
      o.size > e && (e = o.size);
    });
  }), {
    min: 0,
    max: Math.ceil(e / t) * t
  };
}
const te = "elo-apartments-filter-availability";
function We(a, t) {
  const { toggleTag: e, addOrUpdateTag: r } = a, [o, s] = v(void 0);
  C(() => {
    Array.isArray(o) && M(
      te,
      o.filter((i) => !!i.selected)
    );
  }, [o]), C(() => {
    const i = w(
      te
    ) ?? [];
    i.forEach(({ label: n, value: c }) => {
      r(ae(n, c));
    });
    const u = i.map(
      (n) => n.value ?? n.label
    ), d = O.map((n) => {
      const c = t[`${n}Text`] ?? n;
      return {
        icon: "EventAvailable",
        label: c,
        selected: u.includes(c),
        value: n,
        onClick: () => {
          s(
            (g) => Ze(g ?? [], c)
          ), e(ae(c, n));
        }
      };
    });
    s(d);
  }, [r, e, t]);
  const l = b((i) => s(
    (u) => (u ?? []).map(
      (d) => d.label === i.value ? { ...d, selected: !1 } : d
    )
  ), []), m = b(() => {
    s(
      (i) => (i ?? []).map((u) => ({ ...u, selected: !1 }))
    );
  }, []);
  return { availabilityOptions: o, unselectAvailability: l, resetAvailability: m };
}
function ae(a, t) {
  return {
    type: h.availability,
    value: a,
    icon: T.availability,
    data: t
  };
}
function Ze(a, t) {
  return a.map(
    (e) => e.label === t ? { ...e, selected: !e.selected } : e
  );
}
const U = "elo-apartments-filter-rent", K = { min: 0, max: 2e3 };
function et(a, t, e) {
  const r = se(K), [o, s] = v(K), { addUniqueTagOfType: l, removeTagsByType: m } = e, i = b(
    (n) => {
      s(n);
      const c = r.current;
      c.min !== n.min || c.max !== n.max ? (l({
        type: h.rent,
        value: `${n.min}-${n.max} €`,
        icon: T.rent
      }), M(U, n)) : (m(h.rent), P(U));
    },
    [l, m]
  );
  C(() => {
    const n = tt(a);
    r.current = n;
    const c = w(U);
    i(c ?? n);
  }, [a, i]);
  const u = A(() => {
    const n = r.current;
    return {
      scaleFrom: n.min,
      scaleTo: n.max,
      defaultMin: o.min,
      defaultMax: o.max,
      scaleStep: 10,
      onChange: i,
      texts: {
        title: t.rentFilterLabel,
        fromText: `${n.min}€`,
        toText: "2000€ +",
        maximumText: t.maximumLabel,
        minimumText: t.minimumLabel
      }
    };
  }, [
    o,
    i,
    t.maximumLabel,
    t.minimumLabel,
    t.rentFilterLabel
  ]), d = b(() => {
    const n = r.current;
    i(n);
  }, [i]);
  return { rent: o, rentOptions: u, resetRent: d };
}
function tt(a) {
  if (a.length === 0)
    return K;
  const t = 100;
  let e = 0;
  return a.forEach((r) => {
    r.apartments.forEach((o) => {
      o.rent > e && (e = o.rent);
    });
  }), {
    min: 0,
    max: Math.ceil(e / t) * t
  };
}
const ne = "elo-apartments-filter-rooms";
function at({
  addOrUpdateTag: a,
  toggleTag: t
}) {
  const [e, r] = v(void 0);
  C(() => {
    if (Array.isArray(e)) {
      const l = e.filter((m) => !!m.checked).map((m) => m.label);
      M(ne, l);
    }
  }, [e]), C(() => {
    const l = w(ne) ?? [];
    l.forEach((i) => {
      a(re(i));
    });
    const m = Ve.map((i, u, d) => {
      const n = d.length - 1 == u ? `${i} +` : i;
      return {
        value: i,
        label: n,
        checked: l.includes(n),
        onClick: () => {
          r((f) => nt(f ?? [], n)), t(re(n));
        }
      };
    });
    r(m);
  }, [a, t]);
  const o = b((l) => r(
    (m) => (m == null ? void 0 : m.map(
      (i) => i.label === l.value ? { ...i, checked: !1 } : i
    )) ?? []
  ), []), s = b(() => {
    r(
      (l) => (l == null ? void 0 : l.map((m) => ({ ...m, checked: !1 }))) ?? []
    );
  }, []);
  return { roomCountOptions: e, resetRoomCount: s, uncheckRoomCount: o };
}
function re(a) {
  return {
    type: h.roomCount,
    value: a,
    icon: T.roomCount
  };
}
function nt(a, t) {
  return a.map((e) => {
    if (e.label !== t) return e;
    const r = !!e.checked;
    return { ...e, checked: !r };
  });
}
function rt(a, t, e, r) {
  const { removeAllTags: o, removeTag: s } = e, { roomCountOptions: l, resetRoomCount: m, uncheckRoomCount: i } = at(e), { availabilityOptions: u, resetAvailability: d, unselectAvailability: n } = We(e, t), { area: c, areaOptions: f, resetArea: g } = Xe(
    a,
    t,
    e
  ), { rent: k, rentOptions: R, resetRent: x } = et(
    a,
    t,
    e
  ), I = b(
    (_) => {
      if (_)
        switch (s(_), _.type) {
          case h.roomCount:
            return i(_);
          case h.availability:
            return n(_);
          case h.area:
            return g();
          case h.rent:
            return x();
          case h.location:
            return r();
        }
    },
    [
      r,
      s,
      g,
      x,
      i,
      n
    ]
  ), N = b(() => {
    o(), m(), d(), g(), x(), r();
  }, [
    o,
    m,
    d,
    g,
    x,
    r
  ]);
  return {
    roomCountOptions: l,
    availabilityOptions: u,
    areaOptions: f,
    rentOptions: R,
    area: c,
    rent: k,
    handleRemoveAllTags: N,
    handleRemoveTag: I
  };
}
const E = "elo-apartments-filter-location";
function ot({
  googleMapApiKey: a,
  texts: t,
  cities: e,
  selectedTagsOptions: r
}) {
  const { addUniqueTagOfType: o, removeTagsByType: s } = r, [l, m] = v(ee);
  C(() => {
    const n = w(E);
    if (n) {
      const { coordinates: c, query: f } = n;
      c && f && (m(c), o(oe(f)));
    }
  }, [o]);
  const i = b(
    async (n) => {
      const c = Se(n);
      if (c)
        try {
          const f = await Le(
            c,
            a
          );
          f && (m(f), o(oe(n)), M(E, { query: n, coordinates: f }));
        } catch (f) {
          console.error("Error fetching coordinates:", f), m(null), s(h.location), P(E);
        }
    },
    [o, a, s]
  ), u = b(() => {
    m(ee), s(h.location), P(E);
  }, [s]), d = A(() => ({
    placeholder: t.autoCompleteInputPlaceholder,
    dropDownLabel: t.autocompleteDropdownTitle,
    cities: e,
    options: e,
    onOptionClick: i,
    onSearchPress: i,
    googleMapApiKey: a
  }), [
    t.autoCompleteInputPlaceholder,
    t.autocompleteDropdownTitle,
    e,
    a,
    i
  ]);
  return {
    currentLocationCoordinates: l,
    autocompleteInputProps: d,
    clearApartmentsSearch: u
  };
}
function oe(a) {
  return {
    type: h.location,
    value: a,
    icon: T.location
  };
}
function it({
  lang: a,
  requestVerificationToken: t,
  disableDataFetching: e
}) {
  const [r, o] = v(!0), [s, l] = v([]);
  return C(() => {
    const m = async () => {
      if (o(!0), e) {
        const { dummyDataApartmentSearch: u } = await import("./dummy-data-CxkLsr3k.js");
        l(u.result.pages), o(!1);
        return;
      }
      try {
        const u = await Me(
          "/api/ApartmentSearchApi/Get/",
          a,
          t
        );
        l(u.result.pages), M(
          Q,
          u.result.pages
        );
      } catch (u) {
        console.error("Error fetching locations:", u);
      } finally {
        o(!1);
      }
    }, i = w(Q);
    i ? (l(i), o(!1)) : m();
  }, [e, a, t]), { loading: r, apartmentProperties: s };
}
const lt = 20, z = [
  ["helsinki", "espoo", "vantaa"],
  ["tampere"],
  ["turku"]
];
function st(a, t) {
  const { area: e, coordinates: r, rent: o, tags: s } = t, l = A(() => r ? ct(a, r) : mt(a), [r, a]);
  return A(() => {
    const i = [];
    for (const u of l) {
      const d = u.apartments.filter(
        (n) => $e(n, { area: e, rent: o, tags: s, coordinates: null })
      ).sort((n, c) => n.rent - c.rent);
      d.length > 0 && i.push({ ...u, apartments: d });
    }
    return i;
  }, [e, l, o, s]);
}
function ct(a, t) {
  const e = /* @__PURE__ */ new Map();
  for (const r of a) {
    const o = we(r, t);
    o <= lt && e.set(r, o);
  }
  return Array.from(e.keys()).sort(
    (r, o) => (e.get(r) || 0) - (e.get(o) || 0)
  );
}
function mt(a) {
  return a.sort((t, e) => ie(e) - ie(t));
}
function ie(a) {
  const t = z.length;
  for (let e = 0; e < z.length; e++)
    if ((z[e] ?? []).includes(a.apartmentPropertyCity.toLowerCase()))
      return t - e;
  return 0;
}
const At = (a) => {
  const {
    isMapViewDisplayDefault: t = !1,
    texts: e,
    googleMapApiKey: r,
    cities: o,
    lang: s = "EN",
    requestVerificationToken: l,
    disableDataFetching: m
  } = a, { apartmentProperties: i, loading: u } = it({
    lang: s,
    requestVerificationToken: l,
    disableDataFetching: m
  }), [d, n] = v(
    t
  ), c = b(() => {
    n((be) => !be);
  }, []), f = Re(void 0), { selectedTags: g, toggleTag: k } = f, {
    currentLocationCoordinates: R,
    autocompleteInputProps: x,
    clearApartmentsSearch: I
  } = ot({
    googleMapApiKey: r,
    texts: e,
    cities: o,
    selectedTagsOptions: f
  }), {
    roomCountOptions: N,
    availabilityOptions: _,
    areaOptions: ue,
    rentOptions: pe,
    area: Y,
    rent: j,
    handleRemoveAllTags: de,
    handleRemoveTag: fe
  } = rt(
    i,
    e,
    f,
    I
  ), he = A(
    () => ({
      area: Y,
      coordinates: R,
      rent: j,
      tags: g
    }),
    [Y, R, j, g]
  ), F = st(
    i,
    he
  ), q = F.length === 0, H = A(() => ({
    disableMapView: q,
    isDisplayingMapView: d,
    onClickMapView: c,
    openCardViewButtonText: e.openCardViewButtonText,
    openMapViewButtonText: e.openMapViewButtonText
  }), [
    q,
    c,
    d,
    e.openCardViewButtonText,
    e.openMapViewButtonText
  ]);
  return /* @__PURE__ */ p(le, { children: /* @__PURE__ */ y(L, { direction: "column", className: Be["apartment-search"], children: [
    /* @__PURE__ */ p(Fe, { pageTitle: e.pageTitle, ...H }),
    /* @__PURE__ */ p(
      He,
      {
        autocompleteInputProps: x,
        mapButton: H,
        selectedTags: g,
        toggleTag: k,
        onRemoveAllTags: de,
        onRemoveTag: fe,
        texts: e,
        filters: {
          roomCountOptions: N,
          availabilityOptions: _,
          rentOptions: pe,
          areaOptions: ue,
          texts: e
        }
      }
    ),
    u ? /* @__PURE__ */ p(ke, {}) : F.length === 0 ? /* @__PURE__ */ p(
      De,
      {
        noResultHeadingText: e.noResultHeadingText,
        noResultParagraphText: e.noResultParagraphText
      }
    ) : d ? /* @__PURE__ */ p(
      Qe,
      {
        properties: F,
        texts: e,
        googleMapApiKey: r
      }
    ) : /* @__PURE__ */ p(
      Ye,
      {
        properties: F,
        texts: e
      }
    )
  ] }) });
};
export {
  At as ApartmentSearchPage
};
